import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  fieldLabel: {
    color: theme.palette.common.gray800,
    marginBottom: theme.spacing(1),
  },
  fieldGroup: {
    marginBottom: theme.spacing(2),
  },
  radioOptionsContainer: {
    marginLeft: theme.spacing(2),
  },
  radioLabel: {
    marginBottom: theme.spacing(1),
  },
  shadowModeContainer: {
    alignItems: 'center',
    display: 'flex',
    marginTop: theme.spacing(2),
  },
  shadowModeHelperText: {
    color: theme.palette.common.gray600,
    marginLeft: theme.spacing(1),
  },
  subCard: {
    border: `1px dashed ${theme.palette.common.gray400}`,
    borderRadius: theme.shape.borderRadius,
    marginTop: theme.spacing(3),
    padding: theme.spacing(2),
  },
  subCardTitle: {
    color: theme.palette.common.gray800,
    marginBottom: theme.spacing(1),
  },
  subCardDescription: {
    color: theme.palette.common.gray600,
    marginBottom: theme.spacing(2),
  },
  dryRunFieldsRow: {
    display: 'flex',
    gap: theme.spacing(2),
  },
  dryRunButtonContainer: {
    marginTop: theme.spacing(2),
  },
  dryRunResult: {
    marginTop: theme.spacing(2),
  },
  verdictPill: {
    fontWeight: 500,
    marginBottom: theme.spacing(1),
  },
  verdictPillEligible: {
    backgroundColor: theme.palette.common.green100,
    color: theme.palette.common.green800,
  },
  verdictPillNotEligible: {
    backgroundColor: theme.palette.common.red100,
    color: theme.palette.common.red800,
  },
  verdictPillNeutral: {
    backgroundColor: theme.palette.common.gray200,
    color: theme.palette.common.gray800,
  },
  verdictPillWarning: {
    backgroundColor: theme.palette.common.orange100,
    color: theme.palette.common.orange800,
  },
  resultDetailRow: {
    color: theme.palette.common.gray800,
  },
  resultDetailLabel: {
    color: theme.palette.common.gray600,
  },
}));
